module.exports = __webpack_public_path__ + "static/media/contacto_icon_press.44a9d105.svg";